/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFileSignature} from '@fortawesome/pro-duotone-svg-icons';

const RegistrationFormsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faFileSignature} {...props} />
);

export default RegistrationFormsIcon;
